export const formatPhoneNumber = (phoneNumber: string) => {
  phoneNumber = normalizePhoneNumber(phoneNumber)
  if (phoneNumber.length < 3) {
    return phoneNumber
  } else if (phoneNumber.length < 6) {
    return `(${phoneNumber.substring(0, 3)}) ${phoneNumber.substring(3)}`
  } else if (phoneNumber.length <= 10) {
    return `(${phoneNumber.substring(0, 3)}) ${phoneNumber.substring(3, 6)}-${phoneNumber.substring(6)}`
  } else {
    return phoneNumber
  }
}

const re = /^1|[^0-9]/g

export const normalizePhoneNumber = (phoneNumber: string) => {
  phoneNumber = phoneNumber.replace(re, '')
  if (phoneNumber.length > 10) {
    phoneNumber = phoneNumber.substring(0, 10)
  }
  return phoneNumber
}